import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	title: {
		id: 'eoc.escalation-policies.ui.title.no-translate',
		defaultMessage: 'Escalation policies',
		description: 'Title of escalation policies section',
	},
	add: {
		id: 'eoc.escalation-policies.ui.add.no-translate',
		defaultMessage: 'Create escalation policy',
		description: 'Label of create an escalation button',
	},
	emptyAdd: {
		id: 'eoc.escalation-policies.ui.empty-add.no-translate',
		defaultMessage: 'Create now',
		description: 'Label of create an escalation button',
	},
	maxPolicy: {
		id: 'eoc.escalation-policies.ui.max-policy-warning.no-translate',
		defaultMessage: 'You have created 300 escalation policies, which is the maximum you can add.',
		description: 'Warning message that will be shown when there is 300 escalation policy',
	},
	empty: {
		id: 'eoc.escalation-policies.ui.empty-message.no-translate',
		defaultMessage: 'No escalation policies here yet.',
		description: 'Text description that will be shown when there is no escalations',
	},
});

export default messages;
